/* eslint-disable no-empty */
import { Common } from '@stockbit/ui';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { selectors } from 'lib/entities/profile';
import PropTypes from 'prop-types';
import generateNavBar from 'utils/navbar';

import { clevertapEvent } from 'utils/clevertap';
import { CLEVERTAP_EVENT_NAME } from 'constants/clevertap';
import DATA_CY from 'constants/data-cy';
import { NavbarWeb, Navigation } from './styled';
import ReloadHandler from './ReloadHandler';
import Image from 'global/Image';

const { Iconmoon, Text, Flex } = Common;

const NavMoreLogo = () => (
  <Flex width="50px" height="40px" align="center" justify="center">
    <Image src="/icon/navbar-web/tripel-dot.svg" alt="Tripel Dot" />
  </Flex>
);

const Web = ({ minimize, ...otherProps }) => {
  const router = useRouter();
  const { data } = useSelector(selectors);
  const { country = 'ID' } = data;

  const renderExpand = () => {
    if (country === 'ID') {
      return (
        <div data-cy={DATA_CY.NAVIGATION.MORE_MENU_BUTTON}>
          <NavMoreLogo />
        </div>
      );
    }

    return null;
  };

  return (
    <NavbarWeb {...otherProps} minimize={minimize} expandNavLogo={renderExpand}>
      {generateNavBar(data).map((item) => (
        <Navigation
          key={item.label}
          active={item.matcher(router)}
          data-cy={item['data-cy']}
        >
          <ReloadHandler
            href={item.href}
            label={item.label}
            onClick={() => {
              try {
                clevertapEvent(CLEVERTAP_EVENT_NAME.HEADER_MENU, {
                  Action: item.label.toLowerCase(),
                });
              } catch (e) {}
            }}
            isMobile={false}
          >
            <Iconmoon as="a" color="inherit" className={item.logoWeb} />
            <Text as="a" color="inherit" pl="5px">
              {item.label}
            </Text>
          </ReloadHandler>
        </Navigation>
      ))}
    </NavbarWeb>
  );
};

Web.propTypes = {
  minimize: PropTypes.bool,
};

Web.defaultProps = {
  minimize: false,
};

export default Web;
